import { render, staticRenderFns } from "./AjaxSelect.vue?vue&type=template&id=4dc89e6d&scoped=true"
import script from "./AjaxSelect.vue?vue&type=script&lang=js"
export * from "./AjaxSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc89e6d",
  null
  
)

export default component.exports